export const buildEventSource = (
  url: string,
  dict?: EventSourceInit,
): EventSource => new EventSource(url, dict)
